import { send } from 'server';

export const getPaymentStatistics = () => send({
    ID: 35209,
    responses: [35210, 35211],
    description: 'Get payment statistics'
});

export const getTransactionHistory = ({
    type,
    status,
    startTime,
    endTime,
    corrections,
    cancellations
}) => send({
    ID: 33026,
    responses: [33027, 33028],
    description: 'Get transaction history',
    type,
    status,
    startTime,
    endTime,
    corrections,
    cancellations
});

export const cancelWithdraw = ({
    transactionCode,
    reason
}) => send({
    ID: 33020,
    responses: [33021, 33022],
    description: 'Cancel withdraw',
    transactionCode,
    reason
});

export const getDetailedTransactionHistory = ({
    clientPlatform,
    cancellations,
    corrections,
    endTime,
    excludePaymentRequests,
    historyRequestSummary,
    pagingRequestParams,
    reason,
    startTime,
    status,
    transactionCode,
    type
}) => send({
    ID: 35610,
    responses: [35611, 35612],
    description: 'Get detailed transaction history',
    transactionCode,
    reason,
    startTime,
    endTime,
    corrections,
    clientPlatform,
    cancellations,
    excludePaymentRequests,
    pagingRequestParams,
    historyRequestSummary,
    status,
    type
});

export const getBalanceHistory = ({
    startDate,
    endDate,
    clientType,
    orderByDate,
    returnSummary,
    transactionGroups,
    ignorePlayerViewConf,
    ignoreStartingEndingBalances,
    pagerRequest
}) => send({
    ID: 32012,
    responses: [32013, 32014],
    description: 'Get balance history',
    startDate,
    endDate,
    clientType,
    orderByDate,
    returnSummary,
    transactionGroups,
    ignorePlayerViewConf,
    ignoreStartingEndingBalances,
    pagerRequest
});
